import { toast, ToastOptions } from "react-toastify";
const defaultOptions: ToastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};
/**
 * Show a toast notification
 * message {string} to display
 * Message type {string} info, update, success, error
 * ToastOptions
 */
export const notify = (options: {
    message: string;
    messageType: "info" | "update" | "success" | "error" | "warning";
    options?: ToastOptions;
}) => {
    switch (options.messageType) {
        case "error":
            toast.error(options.message, options.options || defaultOptions);
            break;
        case "info":
            toast.info(options.message, options.options || defaultOptions);
            break;
        case "success":
            toast.success(options.message, options.options || defaultOptions);
            break;
        case "update":
            toast.update(options.message, options.options || defaultOptions);
            break;
        case "warning":
            toast.warning(options.message, options.options || defaultOptions);
            break;
        default:
            toast.info(options.message, options.options || defaultOptions);
            break;
    }
};
